import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import BlurImage from '../../components/BlurImage';

const BlurImagePage: React.FC = () => (
  <ToolLayout
    title="Blur Image Online Free - Add Blur Effect | AllTools"
    description="Add blur effect to images online. Adjust blur intensity with live preview. Free image blur tool."
    canonicalPath="/blur-image"
  >
    <BlurImage />
  </ToolLayout>
);

export default BlurImagePage;
